import React from "react";

import CheckIcon from "@mui/icons-material/Check";
import { MenuItemProps, styled, Typography } from "@mui/material";

import { lightOrDark } from "@app/embedded/theme/utils";

import MenuItem from "@rui/Dropdown/MenuItem";
import Stack, { Row } from "@rui/Stack";

interface AccessSelectorItemProps extends MenuItemProps {
  label?: string;
  selected?: boolean;
  isDefault?: boolean;
  description?: string;
}

const StyledMenuItem = styled((props: MenuItemProps) => (
  <MenuItem {...props} />
))(({ theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  maxWidth: "250px",
  padding: theme.spacing(1),
  borderRadius: "8px",
  "&:hover": { backgroundColor: theme.palette.states.hover },
  "&.Mui-selected": {
    backgroundColor: "transparent",
    "&:hover": { backgroundColor: theme.palette.states.hover },
    "&.Mui-focusVisible": {
      backgroundColor: theme.palette.states.hover,
    },
  },
  "&.Mui-focusVisible": {
    backgroundColor: theme.palette.states.hover,
  },
  whiteSpace: "normal",
}));

const AccessSelectorItem = ({
  label,
  selected = false,
  value,
  description,
  ...props
}: AccessSelectorItemProps) => {
  return (
    <StyledMenuItem value={value} {...props}>
      <Stack sx={{ width: "270px", wordWrap: "break-word" }}>
        <Row variant="apart" sx={{ minHeight: "26px" }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography
              variant="bodySecondaryReg"
              sx={{
                fontWeight: selected ? 500 : 400,
                color: (theme) =>
                  selected
                    ? lightOrDark(
                        "shades.neutral.800",
                        "shades.neutral.50"
                      )(theme)
                    : lightOrDark(
                        "shades.neutral.700",
                        "shades.neutral.200"
                      )(theme),
                fontStyle: value === "" ? "italic" : "none",
              }}
            >
              {value === "" ? "None" : label ?? value}
            </Typography>
          </Stack>
          {selected && (
            <CheckIcon
              sx={{
                fontSize: "18px",
                color: (theme) =>
                  lightOrDark(
                    "shades.primary.500",
                    "shades.primary.300"
                  )(theme),
              }}
            />
          )}
        </Row>
        {description && (
          <Typography
            variant="labelReg"
            sx={{
              color: (theme) =>
                lightOrDark("shades.neutral.500", "shades.neutral.200")(theme),
              fontStyle: value === "" ? "italic" : "none",
              display: "flex",
            }}
          >
            {description}
          </Typography>
        )}
      </Stack>
    </StyledMenuItem>
  );
};

export default AccessSelectorItem;
